//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectGroup.js";
import "../no/SelectObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ActionType",1,0],[0,"ActivegroupOption",1,0],[0,"AttributeHolder",0,"TaggedObject",0],[0,"GroupDisplayProperties",1,0],[1,"GroupInAction",0,"SelectGroup",0],[0,"GroupName",1,0],[1,"ObjectsInGroup",0,"SelectObjectList",0],[0,"OwningObject",1,"NXObject",0],[0,"SketchGroupType",1,0],[0,"UngroupLevel",1,0],[0,"UniqueMembershipOption",1,0]],[],[]];
SPLM.GroupBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GroupBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GroupBuilder.Action = Object.freeze({
    "NewGroup" : "NewGroup", "AddToGroup" : "AddToGroup", "RemoveFromGroup" : "RemoveFromGroup", "Ungroup" : "Ungroup", "EditGroup" : "EditGroup", "NewSketchGroup" : "NewSketchGroup"});

SPLM.GroupBuilder.SketchType = Object.freeze({
    "Regular" : "Regular", "Unique" : "Unique", "Rigid" : "Rigid", "Scalable" : "Scalable"});

SPLM.GroupBuilder.UngroupOption = Object.freeze({
    "Top" : "Top", "Full" : "Full"});

export default SPLM;